import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

export const regionOptions = ["APAC", "EMEA", "LATAM", "NA"];

const PSTN_cloud_group = yup.object({
  geographic_PSTN: yup.boolean().required(),
  emergency_dialing: yup.boolean().required(),
  toll_free_dialing: yup.boolean().required(),
  short_code_dialing: yup.boolean().required(),
  caller_id_support: yup.boolean().required(),
});
const inbound_cloud_group = yup.object({
  geographic_inbound: yup.boolean().required(),
  national_inbound: yup.boolean().required(),
  toll_free_inbound: yup.boolean().required(),
});
const porting = yup.object({
  geographic_PSTN_2: yup.boolean().required(),
  geographic_inbound_2: yup.boolean().required(),
  national_inbound2: yup.boolean().required(),
  toll_free_inbound_2: yup.boolean().required(),
});

const meet_audio = yup.object({
  geographic: yup.boolean().required(),
  toll_free: yup.boolean().required(),
});
const x_series = yup.object({
  X1: yup.boolean().required(),
  X2: yup.boolean().required(),
  X3: yup.boolean().required(),
  X4: yup.boolean().required(),
  X6: yup.boolean().required(),
  X7: yup.boolean().required(),
  X8: yup.boolean().required(),
});
const international = yup.object({
  region: yup.string().oneOf(regionOptions).required(),
  PSTN_cloud: yup.boolean().required(),
  country: yup.string().required(),
  inbound_cloud: yup.boolean().required(),
  PSTN_cloud_group,
  inbound_cloud_group,
  porting,
  meet_audio_dialin_numbers: meet_audio,
  X: x_series,
  PSTN_cloud_carrier: yup.string().nullable(),
  phone_number_tier: yup.number().required(),
  hard_phones: yup.string().required(),
  PSTN_gateway_support: yup.boolean().required(),
  product_support: yup.string().required(),
});

const subnet = yup.object({
  region: yup.string().required(),
  service: yup.string().required(),
  subnetString: yup.string().required(),
  portUsage: yup.string().required(),
  QOS: yup.boolean().required(),
  ACL: yup.boolean().required(),
  is_proxy: yup.boolean().required(),
  is_non_proxy: yup.boolean().required(),
  is_data_center: yup.boolean().required(),
});

addKeyToFieldsRecursively(international);
addKeyToFieldsRecursively(subnet);

export { international, subnet };
